import React from 'react'
import { TextField } from 'material-ui'
import './styles.css'
import { sendSMS } from '../../../services/promo.service'

export default class SendCampaignMessagePage extends React.Component {
  constructor(props) {
    super(props)
    const url = new URL(window.location.href)
    const tenant = url.searchParams.get('tenant')
    this.state = {
      mobile: undefined,
      tenant: tenant,
      campaignUrl: null,
      message: undefined
    }
  }

  postMessageTo = async () => {
    const { mobile, tenant } = this.state
    const campaignInfo = await sendSMS(mobile, tenant)
    this.setState({
      campaignUrl: campaignInfo['shortUrl'],
      message: `Message Sent to ${mobile} Successfully.`,
      mobile: undefined
    })
  };

  render() {
    const { mobile, campaignUrl, message } = this.state
    return (
      <div style={{ textAlign: 'center', fontSize: 20 }}>
        <img
          src='https://rules.casa.croma.com/public-html/cromapromo/croma-screen-one-new-new.png'
          style={{ width: '70%', display: 'inline-block' }}
          alt="croma logo"
        />
        <br />
        <div style={{ textAlign: 'left', marginTop: 20, display: 'inline-block' }}>
          Enter the number to send message:
          <br />
          <div style={{ width: '100%', display: 'inline-block' }}>
            <TextField
              value={mobile}
              // variant="outlined"
              placeholder="Number to send message"
              onChange={event => this.setState({ mobile: event.target.value })}
              style={{ width: '100%', marginTop: 10, fontSize: 20 }}
              inputStyle={{ textAlign: 'center' }}
              // onInput={e => {
              //   e.target.value = e.target.value.toString().slice(0, 10)
              // }}
            />
          </div>
        </div>
        <br />
        <div style={{ display: 'inline-block' }}>
          <button
            style={{
              backgroundColor: '#F58974',
              color: '#FFFFFF',
              marginTop: 20,
              padding: 10,
              borderRadius: 8,
              border: '1px solid #F58974',
              boxShadow: 0,
              fontSize: 16
            }}
            onClick={this.postMessageTo}
          >
            Send Message
          </button>
        </div>
        <br />
        {campaignUrl && (
          <div style={{ textAlign: 'center', marginTop: 25, display: 'inline-block' }}>
            <div>{message}</div>
            {/* <div style={{ marginTop: 10 }}>*/}
            {/*  The link sent to the {mobile} is{' '}*/}
            {/*  <a href={campaignUrl} target="_blank" rel="noopener noreferrer">*/}
            {/*    {campaignUrl}*/}
            {/*  </a>*/}
            {/* </div>*/}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/SendCampaignMessage/containers/index.js